// Module
var code = "<td class=\"timewriting-table-column__value\" data-bind=\"css: _cell.ClassName, visible: _cell.Visible\"> <div class=\"timewriting-table-mobile-label\"><span data-bind=\"text: _cell.Label\"></span>:</div> <span> <!-- ko with: _cell.Value --> <!-- ko text: $parent.FormatValue(DisplayValue) --> <!-- /ko --> <!-- /ko --> </span> </td>";
// Exports
export default code;